import { get, post } from "@/utils/request";
//工商变更申请
export const businessApply = (params: any) => post("/api/businessChange/submitApply", params);
//工商变更详情
export const businessDetailApi = (params: any) => post("/api/businessChange/detail", params);
//获取工商变更节点信息
export const NodeInfoApi = (params: any) => post("/api/processNodes/getBusinessChangeNodeInfo", params);
//撤回工商变更
export const businessWithDrawApi = (params: any) => post("/api/businessChange/withdraw", params);
//工商变更审批
export const businessApproveApi = (params: any) => post("/api/businessChange/approve", params);
//其他模块审批
export const companyFlowApproveApi = (params: any) => post("/api/companyFlow/approve", params);
//工商变更列表
export const getApplyList = (params: any) => post("/api/businessChange/pageList", params);
//地址变更申请
export const addressApplyApi = (params: any) => post("/api/addressChange/submitApply", params);
//地址变更详情
export const addressDetailApi = (params: any) => post("/api/addressChange/detail", params);
//房屋租赁申请
export const houseRentApplyApi = (params: any) => post("/api/houseRentChange/submitHouseRentChangeApply", params);
//房屋租赁详情
export const houseRentDetailApi = (params: any) => post("/api/houseRentChange/houseRentChangeDetail", params);
//房屋租赁回传
export const houseRentTurnApi = (params: any) => post("/api/houseRentChange/turnaroundHouseRentChangeApply", params);
//房屋租赁撤回回传
export const houseRentRecallApi = (params: any) => post("/api/houseRentChange/recallTurnaroundHouseRentChangeApply", params);
//装修、采购协议申请
export const decproApplyApi = (params: any) => post("/api/decproChange/submitDecproChangeApply", params);
//装修、采购协议详情
export const decproDetailApi = (params: any) => post("/api/decproChange/decproChangeDetail", params);
//装修、采购协议回传
export const decproTurnApi = (params: any) => post("/api/decproChange/turnaroundDecproChangeApply", params);
//装修、采购协议撤回回传
export const decproRecallApi = (params: any) => post("/api/decproChange/recallTurnaroundDecproChangeApply", params);
//资料及用印申请
export const resourceApplyApi = (params: any) => post("/api/resourceChange/submitResourceChange", params);
//资料及用印详情
export const resourceDetailApi = (params: any) => post("/api/resourceChange/resourceChangeDetail", params);
//税务迁址申请
export const taxAddressApplyApi = (params: any) => post("/api/resourceChange/submitTaxAddressChange", params);
//税务迁址详情
export const taxAddressDetailApi = (params: any) => post("/api/resourceChange/taxAddressChangeDetail", params);
//印章证照刻制申请
export const sealLicenseApplyApi = (params: any) => post("/api/resourceChange/submitSealLicenseChange", params);
//印章证照刻制详情
export const sealLicenseDetailApi = (params: any) => post("/api/resourceChange/sealLicenseChangeDetail", params);


